module.exports = __webpack_public_path__ + "static/belt_of_giant_strength-e459a28f596d09d843567a9b69c98a1a.png";